import type {
  AppliedFilter,
  FilterDraft,
  FilterField,
  FilterOption,
} from "@/components/BlotterFilterBar";

/** The panel's starting draft for a field: its applied op + a copy of its values. */
export function draftFromFilters(filters: AppliedFilter[], fieldId: string): FilterDraft {
  const existing = filters.find((f) => f.fieldId === fieldId);
  return { op: existing?.op ?? "is", values: [...(existing?.values ?? [])] };
}

/** Commits a draft: replaces the field in place, appends it, or removes it when empty. */
export function applyFilterDraft(
  filters: AppliedFilter[],
  fieldId: string,
  draft: FilterDraft,
): AppliedFilter[] {
  if (draft.values.length === 0) return filters.filter((f) => f.fieldId !== fieldId);
  const next: AppliedFilter = { fieldId, values: [...draft.values], op: draft.op };
  return filters.some((f) => f.fieldId === fieldId)
    ? filters.map((f) => (f.fieldId === fieldId ? next : f))
    : [...filters, next];
}

export function visibleOptions(options: FilterOption[], query: string): FilterOption[] {
  const q = query.trim().toLowerCase();
  if (!q) return options;
  return options.filter((o) => o.label.toLowerCase().includes(q));
}

export function filterChipText(field: FilterField, filter: AppliedFilter, panel: boolean): string {
  const values = filter.values
    .map((v) => field.options.find((o) => o.value === v)?.label ?? v)
    .join(", ");
  if (!panel) return `${field.label}: ${values}`;
  return `${field.label} ${filter.op === "isnot" ? "is not" : "is"} ${values}`;
}
